import { salaryWealthCreation, futureValueStepUpSIP } from "../../engine/calculations";

const config = {
  key: "salary-wealth-creation",
  title: "Salary Wealth Creation",
  category: "Wealth Strategies",
  description: "Save a fixed % of your salary every month, with both rising each year, and see the wealth it builds.",
  fields: [
    { key: "monthlyIncome", label: "Current monthly income", type: "currency", default: 1_00_000, min: 5000, max: 50_00_000 },
    { key: "savingsPct", label: "% of income you save", type: "percent", default: 20, min: 1, max: 80 },
    { key: "annualStepUpPct", label: "Annual step-up (income & savings)", type: "percent", default: 10, min: 0, max: 50, help: "How much your income — and so your savings — rises each year." },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Investment period (years)", type: "number", default: 20, min: 1, max: 40 },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "invested", label: "Invested", colorVar: "--muted" },
      { key: "value", label: "Wealth", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const monthlyIncome = Number(values.monthlyIncome) || 0;
    const savingsPct = (Number(values.savingsPct) || 0) / 100;
    const annualStepUpPct = (Number(values.annualStepUpPct) || 0) / 100;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;
    const startMonthly = monthlyIncome * savingsPct;

    const series = [];
    let invested = 0;
    let monthly = startMonthly;
    for (let y = 1; y <= years; y++) {
      invested += monthly * 12;
      series.push({ year: y, invested, value: futureValueStepUpSIP(startMonthly, annualRate, y, annualStepUpPct) });
      monthly = monthly * (1 + annualStepUpPct);
    }

    const futureValue = salaryWealthCreation(monthlyIncome, savingsPct, annualStepUpPct, annualRate, years);
    const totalInvested = invested;

    return {
      headline: { label: "Wealth built", value: futureValue },
      breakdown: [
        { label: "Starting monthly savings", value: startMonthly },
        { label: "Total Invested", value: totalInvested },
        { label: "Estimated Gains", value: futureValue - totalInvested },
      ],
      series,
    };
  },
};

export default config;
